/* eslint-disable @typescript-eslint/no-unused-expressions */
import { GKClientDataGrid, Grid2, Show, Typography } from "components";
import { useAppSelector } from "store/store";
import { extraColumnsField } from "utils/helpers";

const ViewSettingsTab = () => {
  const { selectedBasket: data } = useAppSelector(
    (state) => state?.equityBasket,
  );

  const partnerList = useAppSelector((state) => state.app.partnerList)?.filter(
    (d) => data?.partners.includes(d.id),
  );

  return (
    <Grid2 container rowSpacing={3}>
      <Grid2 size={4}>
        <Typography>Basket published on</Typography>
      </Grid2>
      <Grid2 size={8}>
        {!data?.published ? (
          <Typography color="#2d2d2d77">*Not Yet Publised</Typography>
        ) : (
          <Typography fontWeight={600}>Micro Website</Typography>
        )}
      </Grid2>
      <Grid2 size={4}>
        <Typography>Basket published for (Partners)</Typography>
      </Grid2>
      <Grid2 size={8}>
        <Show.When
          isTrue={partnerList?.length !== 0}
          showNodata
          textContent="Not assigned to any partner"
        >
          <GKClientDataGrid
            name="viewEBPartners"
            density="compact"
            showHeaderGrid={false}
            pagination={false}
            rows={partnerList || []}
            columns={[
              {
                ...extraColumnsField("Name", "name", 150, 1),
              },
              {
                ...extraColumnsField("Code", "code", 150, 1),
              },
              {
                ...extraColumnsField("Email", "email", 150, 1),
              },
              {
                ...extraColumnsField("Phone", "phone", 150, 1),
              },
              {
                ...extraColumnsField("Branch", "headBranch", 150, 1),
              },
            ]}
          />
        </Show.When>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontWeight={600}>Subscription settings</Typography>
      </Grid2>
      {[
        {
          title: "Allocation",
          value: data?.allowAllocation ? "Enabled" : "Disabled",
        },
        {
          title: "Allocation Reference Weightage",
          value: data?.rebalanceReferenceValue,
        },
        {
          title: "Rebalance",
          value: data?.allowRebalance ? "Enabled" : "Disabled",
        },
        {
          title: "Rebalance Reference Weightage",
          value: data?.rebalanceReferenceValue || "-",
        },
        {
          title: "Allow Low Risk Score",
          value: data?.allowLowRiskProfile ? "Yes" : "No",
        },
      ]?.map((dataItem) => {
        return (
          <Grid2 size={12} container>
            <Grid2
              size={4}
              pb={3}
              borderBottom={`solid 1px var(--neutral-100)`}
            >
              <Typography>{dataItem?.title}</Typography>
            </Grid2>
            <Grid2
              size={8}
              pb={3}
              borderBottom={`solid 1px var(--neutral-100)`}
            >
              <Typography fontWeight={600}>{dataItem?.value}</Typography>
            </Grid2>
          </Grid2>
        );
      })}
    </Grid2>
  );
};

export default ViewSettingsTab;
